"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiAlertOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        root: {
            padding: spacing(2, 2, 2, 4),
            boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.35)",
        },
        filledSuccess: {
            fontWeight: undefined,
        },
        filledWarning: {
            fontWeight: undefined,
            color: palette.common.black,
        },
        filledError: {
            fontWeight: undefined,
        },
        standardSuccess: {
            backgroundColor: palette.background.paper,
            color: palette.text.secondary,
            boxShadow: "none",
            "& $action": {
                padding: spacing(2, 2, 0, 2),
            },
            "& $icon": {
                color: "inherit",
            },
        },
        standardError: {
            backgroundColor: palette.background.paper,
            color: palette.error.light,
            boxShadow: "none",
            "& $action": {
                padding: spacing(2, 2, 0, 2),
            },
            "& $icon": {
                color: "inherit",
            },
        },
        icon: {
            padding: spacing(2, 4, 2, 0),
            marginRight: undefined,
            "& .MuiSvgIcon-root": {
                margin: "calc(-0.5em + " + spacing(2) + "px)",
            },
        },
        message: {
            padding: spacing(2, 2, 2, 0),
        },
        action: {
            paddingLeft: spacing(4),
            alignItems: "flex-start",
            marginRight: undefined,
            "& .MuiSvgIcon-root": {
                margin: "calc(-0.5em + " + spacing(2) + "px)",
            },
        },
    });
};
//# sourceMappingURL=MuiAlert.js.map